module.exports = __webpack_public_path__ + "img/great_communication.621e7314.svg";